module.exports = __webpack_public_path__ + "static/media/my-favorites.1dbdbbf4.svg";